/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './TrackCompetitors.module.scss';

export default function TrackCompetitors({ redirectUrl }) {
  const location = useLocation();
  const EcsPortalCompetitors = location.pathname === '/csportal/ecs';
  const redireactionFunctions = (href) => {
    window.location.href = href;
  };
  return (
    <>
      {EcsPortalCompetitors && (
        <div className="p-20">
          <ul className={`${styles.TrackCompetitors__itemlist}`}>
            <li
              className={`${styles.TrackCompetitors__item} whitefill_animate`}
              onClick={() => redireactionFunctions(redirectUrl.manageCampaign)}
            >
              <div className={`${styles.TrackCompetitors__imgbox}`}>
                <img
                  alt="ecs_upgrade"
                  className={`${styles.TrackCompetitors__image}`}
                  src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/ecs_upgrade.png"
                />
              </div>
              <div className={`${styles.TrackCompetitors__textbox} font12 fw500 color111 mt-10`}>
                Upgrade and Start getting leads
              </div>
            </li>
            <li
              className={`${styles.TrackCompetitors__item} whitefill_animate`}
              onClick={() => redireactionFunctions(redirectUrl.ecsHistory)}
            >
              <div className={`${styles.TrackCompetitors__imgbox}`}>
                <img
                  alt="ecs_history_icon"
                  className={`${styles.TrackCompetitors__image}`}
                  src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/ecs_history.png"
                />
              </div>
              <div className={`${styles.TrackCompetitors__textbox} font12 fw500 color111 mt-10`}>Past ECS history</div>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}

TrackCompetitors.propTypes = {
  redirectUrl: PropTypes.object,
};
